const configuredEmail = import.meta.env.VITE_SUPPORT_CONTACT_EMAIL?.trim();
const configuredWhatsApp = import.meta.env.VITE_SUPPORT_WHATSAPP?.trim();

/** One client-side source for tenant-facing Support contact routes. Deployments
 * can override either value without changing the Help UI. */
export const SUPPORT_CONTACT = {
  email: configuredEmail || "info@coliviq.de",
  whatsapp: (configuredWhatsApp || "498954193354").replace(/[^\d]/g, ""),
} as const;

export const SUPPORT_CONTACT_WHATSAPP_URL = `https://wa.me/${SUPPORT_CONTACT.whatsapp}`;
